<template>
	<div class="ipv6-detail-container">
		<!--头部-->
		<div class="jc-page-header">
			<el-page-header show-back-icon :title="$t('ipv6.text.ipv6')" @back="jumpToUp()" class="relative">
				<template slot="content">
					<span class="long-name" :title="gridData.ipv6GatewayName">
						{{gridData.ipv6GatewayName}}
					</span>
					<div class="jc-list__header--right jc-box-action" v-if="false">
						<!--操作-->
						<drop-down-operation :operations="availableOperatesArray"
							@clickSelectItem="selectOps"
							:buttonTitle="$t('privateNetwork.operate')">
						</drop-down-operation>
					</div>
				</template>
			</el-page-header>
		</div>
		<div class="jc-page-content">
			<el-tabs type="border-card" v-model="tabName">
				<!--资源信息-->
				<el-tab-pane
					:label="$t('detail.text.sourceInfo')"
					name="sourceInfo">
					<!--基本信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list jc-datashow-list-inline align-left"
								:rules="rules"  @submit.native.prevent>
								<el-row :gutter="20">
									<el-col :span="8">
										<!--ID-->
										<el-form-item :label="$t('detail.text.id') | withColon">
											<p>
												<span>{{gridData.ipv6GatewayId | maybeEmpty}}</span>
                        <copy-value :copyVal="`${gridData.ipv6GatewayId}`"></copy-value>
												<!-- <span @mouseout="copyHover = false">
													<el-button :disabled="gridData.ipv6GatewayId === undefined"
														v-clipboard:copy="ipv6GatewayId"
														v-clipboard:success="copyToClipboard"
														v-clipboard:error="failToCopy" id="copy-button"
														type="text" icon="el-icon-document-copy">
													</el-button>
												</span> -->
											</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--网关名称-->
										<el-form-item :label="$t('ipv6.text.gatewayName') | withColon"
											class="edit-jc-form"
											prop="editName">
											<span :title="gridData.ipv6GatewayName" class="instance-name">{{ gridData.ipv6GatewayName}}</span>
											<el-popover ref="editValue"
												trigger="click"
												:visible-arrow="false"
												:offset="0"
												placement="left-start"
												:width="300"
												v-if="showEditName"
												:value="showEditName">
												<edit-value :inputVal="gridData.ipv6GatewayName"
													v-if="showEditName"
													@sureEdit="editName"
													:inputValRule="rules.name"
													:showEditDes.sync="showEditName"
													:popTitle="$t('privateNetwork.editName')">
												</edit-value>
											</el-popover>
											<el-button type="text" icon="jc-icon-edit"
												@click="showEditName = true"
												v-popover:editValue>
											</el-button>
											<div class="jc-colude-mask" v-if="showEditName"></div>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--地域-->
										<el-form-item :label="$t('ipv6.text.region') | withColon">
											<p>{{regions[region]|maybeEmpty}}</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--私有网络-->
										<el-form-item :label="$t('ipv6.text.privateNetwork') | withColon">
												<p><a href="javascript:void(0)" @click="jumpToVpcDetail('source', gridData.vpcName, gridData.vpcId)">{{gridData.vpcName}}</a></p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--创建时间-->
										<el-form-item :label="$t('ipv6.text.createTime') | withColon">
											<p>{{gridData.createTime  | maybeEmpty}}</p>
										</el-form-item>
									  </el-col>
								</el-row>
							</el-form>
						</div>
					</div>
				</el-tab-pane>
				<!--IPv6公网带宽-->
				<el-tab-pane
					:label="$t('ipv6.text.ipv6Eip')"
					name="ipv6Eip"
					>
					<!-- IPv6公网列表 -->
					<div class="jc-container-table">
						<div class="jc-container-table-actionBar flex-display dark-gray-background">
							<!--刷新、地域、申请-->
							<el-form class="jc-table-actionBar-item" :inline="true">
								<el-form-item>
									<el-button icon="jc-icon-refresh-line" class="jc-button-icon"
										@click="updateList('refresh')">
									</el-button>
								</el-form-item>
								<el-form-item>
									<el-tooltip
                                    placement="right"
                                    :disabled="isVip">
										<div slot="content">
											{{$t('ipv6.speechCraft.openPublicnetworkTip1')}}
											<a :href="Config.WORK_URL">
												{{$t('ipv6.speechCraft.openPublicnetworkTip2')}}
											</a>
											{{$t('ipv6.speechCraft.openPublicnetworkTip3')}}
										</div>
										<span><el-button type="primary"
											:disabled="!isVip"
											@click="jumpToCreate">
											{{$t('ipv6.text.openPublicnetwork')}}
										</el-button></span>
									</el-tooltip>
								</el-form-item>
							</el-form>
							<!--搜索-->
							<el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>
								<el-form-item>
									<el-input
										class="search-input"
										v-entire-placeholder
										@keyup.enter.native="updateList('refresh')"
										:placeholder="currentPlaceholder"
										v-model="currentSearchValue">
										<el-select
											slot="prepend" id="my-select" v-model="currentSearch"
											@change="changeSearch"
											:placeholder="$t('ipv6.text.gatewayId')"
											style="width:90px">
											<el-option class="my-select-input" v-for="item in searchSelect"
												:key="item.searchValue"
												:label="item.searchLabel" :value="item.searchValue">
											</el-option>
										</el-select>
										<el-button
											slot="append" icon="jc-icon-search" class="search-icon"
											@click="updateList('refresh')">
										</el-button>
									</el-input>
								</el-form-item>
							</el-form>
						</div>
						<!--ipv6列表-->
						<el-table
							:data="tableData"
							class="jc-list-table jc-table-header-cell" v-loading="refreshLoading"
							ref="listTable"
							:empty-text="$t('speechCraft.listEmptyText')">
							<!--IPv6 ID-->
							<el-table-column :label="$t('ipv6.text.ipv6Id')"
								min-width="120"
								key="ipv6AddressId"
								>
								<template slot-scope="scope">
									<span>{{scope.row.ipv6AddressId | maybeEmpty}}</span>
								</template>
							</el-table-column>
							<!--IPv6地址-->
							<el-table-column prop="vpcName"  :label="$t('ipv6.text.ipv6Address')"
								min-width="140">
								<template slot-scope="scope">
									<span>{{scope.row.ipv6Address+'('+transformCharge(scope.row.type)+')' | maybeEmpty}}</span>
								</template>
							</el-table-column>
							<!--可用区-->
							<el-table-column prop="azName"  :label="$t('ipv6.text.az')"
								width="80">
								<template slot-scope="scope">
									<span>{{scope.row.azName | maybeEmpty}}</span>
								</template>
							</el-table-column>
							<!--私有网络-->
							<el-table-column prop="vpcName"  :label="$t('ipv6.text.privateNetwork')"
								>
								<template slot-scope="scope">
									<span>{{scope.row.vpcName | maybeEmpty}}</span>
								</template>
							</el-table-column>
							<!--实例类型-->
							<el-table-column prop="instanceType"  :label="$t('eip.text.instanceType')"
								>
								<template slot-scope="scope">
									<span>{{scope.row.instanceType ?
										InstanceTypeConstant[scope.row.instanceType.toUpperCase()] : '' |
										maybeEmpty}}</span>
								</template>
							</el-table-column>
							<!--实例名称-->
							<el-table-column prop="instanceName"  :label="$t('slb.text.slbName')"
								>
								<template slot-scope="scope">
									<span>{{scope.row.instanceName | maybeEmpty}}</span>
								</template>
							</el-table-column>
							<!--带宽上限-->
							<el-table-column prop="bandwidth"  :label="$t('ipv6.text.bandwidthLimit')"
								>
								<template slot-scope="scope">
									<span class="english-wrap">
									  {{scope.row.bandwidth + 'Mbps'}}
									</span>
									<p>
										{{scope.row.bandwidthPackageId?$t('eip.text.bandwidthPackage'):$t('slb.text.constBandWidth')}}
									</p>
								</template>
							</el-table-column>
							<!--计费信息-->
							<el-table-column prop="createTime"  :label="$t('privateNetInstance.listTitle.charge')"
								min-width="130">
								<template slot-scope="scope">
									<div v-if="scope.row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
										<p>
											{{scope.row.chargeModeName}}
											<span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
												class="status-error">
												{{ '(' + $t('privateNetInstance.arrear') + ')' }}
											</span>
										</p>
										<p class="list-expire-p bill-info-tip"
											v-if="scope.row.charge.chargeStatus === 'normal'">
											{{scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create')}}
										</p>
										<p class="list-expire-p status-error"
											v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.charge.chargeRetireTime">
											{{scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed')}}
										</p>
									</div>
									<div v-else>
										<span>--</span>
									</div>
								</template>
							</el-table-column>
							<!--操作-->
							<el-table-column key="operation"
								:label="$t('listPage.tableLabel.operation')"
								min-width="120">
								<template slot-scope="scope">
									<!-- <a href="javascript:void(0)" @click="modifyBandwidth(scope.row)"
										class="cps-select-form-item"
										:class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus || disableByChargeStatus(scope.row) }">
										{{$t('eip.text.modifyBandwidth')}}
										<--无计费信息不支持添加操作-->
										<!-- <div class="cps-form-tip" v-if="!scope.row.chargeStatus">
											{{ $t('eip.help.noChargeInfo') }}
										</div> -->
										<!-- 实例已过期/欠费不支持操作 -->
										<!-- <div class="cps-form-tip" v-else-if="scope.row.chargeStatus !== 'normal'">
											{{ $t('privateNetInstance.operations.overdueTip') }}
										</div> --
									</a> -->
									<!-- <a href="javascript:void(0)" @click="deleteIpv6Address(scope.row)"
										class="cps-select-form-item"
										:class="{ 'cps-dropdown-disabled': canNotDelete || !scope.row.chargeStatus}">
										{{$t('ipv6.text.deleteIpv6PublicNetwork')}}
										<无计费信息不支持添加操作-->
										<!-- <div class="cps-form-tip" v-if="!scope.row.chargeStatus">
											{{ $t('eip.help.noChargeInfo') }}
										</div>
									</a> -->
                                    <div style="display: flex;">
                                        <el-button type="text" @click="modifyBandwidth(scope.row)" :disabled="!scope.row.chargeStatus || disableByChargeStatus(scope.row)">
                                            {{$t('eip.text.modifyBandwidth')}}
                                        </el-button>
                                        <el-button type="text" @click="deleteIpv6Address(scope.row)" :disabled="canNotDelete || !scope.row.chargeStatus">
                                            {{$t('ipv6.text.deleteIpv6PublicNetwork')}}
                                        </el-button>
                                    </div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="cps-page-footer-simple block jc-container-table-actionBar" v-if="total > 0">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="currentPage"
							:page-sizes="pageSizes" :page-size="pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="total">
						</el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>

		<div v-if="copyHover" class="jc-tooltip__popper is-dark copy-success" x-placement="bottom">{{
			$t('detail.text.copySuccess') }}
			<div class="popper__arrow copy-success-arrow"></div>
		</div>
		<modify-bandwidth :dialog-visible="modifyDialogVisible"
			@ifDialogVisible="syncModifyDialogVisibleData"
			:detail-data="currentRow"
			pageType="IPV6">
	  	</modify-bandwidth>
		<!--ipv6公网访问-->
		<delete-ipv6
			:visible.sync="deleteIpv6Visible"
			@refresh="operateRefresh"
            @canNotDelete="handleCanNotDelete"
            @canDelete="handleCanDelete"
			:rowInfo="currentRow">
		</delete-ipv6>
	</div>
</template>

<script>
	import editValue from '@/components/privateNetwork/EditValue';
  import copyValue from '@/components/privateNetwork/CopyValue';
	import {
		ChargeModeMap,
		Ipv6OperationConstant,
		EIPAssociateConstant,
		ArrearConstantArray,
		InstanceTypeConstant,
		OverdueConstantArray,
		ChargeModeConstant,
		NetworkTypeConstant
	} from '@/common/Constants';
	import DeleteIpv6 from '@/components/common/DeleteIpv6';
	import ModifyBandwidth from '@/components/common/modifyBandwidth/ModifyBandwidth';
	import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
    const defaultPage = 1;
	const defaultPageSize = 20;
	export default {
		components: {
			editValue,
			copyValue,
			DeleteIpv6,
			ModifyBandwidth,
			dropDownOperation
		},
		data() {
			// 模糊搜索条件设置
			const searchSelect = [
				{
					searchValue: 'ipv6Address',
					searchLabel: this.$t('ipv6.text.ipv6Address')
				},
				{
					searchValue: 'ipv6Id',
					searchLabel: this.$t('ipv6.text.ipv6Id')
				}
			];
			const valName = (rule, value, callback) => {
			  	const reg = new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$');
			  	if (!reg.test(value)) {
					callback(new Error(this.$t('create.help.instanceNameRule')));
			  	} else {
					callback();
			  	}
			};
			return {
				tabName: 'sourceInfo',
				ipv6GatewayId: '',
				// 支持的操作
				operatesArr: [

				],
				// 当前IPv6网关支持的操作
				availableOperatesArray: [],
				selectOperate: '1',
				//用户是否打标
				isVip:false,
				gridData: {},
				showEditName: false,
                rules: {
					name: [
						{
							required: true,
							message: this.$t('privateNetwork.nameNotNull'),
						},
						{
							validator: valName,
						}
					],
				},
				currentSearch: 'ipv6Address',
				// 当前搜索input框值
				currentSearchValue: '',
				// 搜索条件下拉选
				searchSelect,
				// 当前搜索条件对应placeholder
				currentPlaceholder: this.$t('ipv6.placeholder.search.ipv6Address'),
				currentPage: defaultPage,
				pageSize: defaultPageSize,
				pageSizes: [20, 50, 100], // 可选每页展示多少条
				total: 0,
				region: '',
				regions: {},
				copyHover: false,
				// 云物理服务器个数
				total: 0,
				tableData: [],
				refreshLoading: false,
				// 编辑名称弹框
				nameFlag: false,
				// 删除ipv6公网弹框
				deleteIpv6Visible: false,
				currentRow: {},
				modifyDialogVisible: false,
                canNotDelete: false, // 不能点击“删除公网访问”按钮
			};
		},
		computed: {
			ChargeModeMap: () => ChargeModeMap,
			EIPAssociateConstant: () => EIPAssociateConstant,
			InstanceTypeConstant: () => InstanceTypeConstant,
			OverdueConstantArray: () => OverdueConstantArray,
			ArrearConstantArray: () => ArrearConstantArray,
			ChargeModeConstant: () => ChargeModeConstant,
		},

		async created() {
			this.ipv6GatewayId = this.$route.query.id;
			this.subnetId = this.$route.query.subnetId;
			this.region = this.$route.query.region;
			this.tabName = this.$route.query.tabName;
			await this.getRegions();
			this.getServerData(true);
			this.getUserType();
			this.getIpv6ListData();

		},
		watch: {},
		methods: {
			/**
        		* 获得region和regionName对照
	    	*/
		    getRegions() {
		        const params = {
		            networkType: NetworkTypeConstant.VPC
		        };
		        return Ajax.get('api/cps/getRegions', params).then((res) => {
		            if (res.data) {
		                res.data.regions.forEach((region) => {
		                    this.regions[region.region] = region.regionName;
		                });
		            }
		        });
		    },
			// 获取IPv6地址列表
			getIpv6ListData() {
                this.$refs.listTable.doLayout();
                this.refreshLoading = true;
				// 基础参数
				const param = {
					region: this.region,
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
					enableInternet: 'yes',
					ipv6GatewayId: this.ipv6GatewayId
				};
				// 搜索部分添加参数
				if (this.currentSearchValue !== '') {
					switch (this.currentSearch) {
						case 'ipv6Address': {
							param.ipv6Address = this.currentSearchValue;
							break;
						}
						case 'ipv6Id': {
							param.ipv6AddressIds = this.currentSearchValue;
							break;
						}
						default:
					}
				}
				Ajax.get('/api/cps/queryListIpv6Addresses', param)
				.then((res) => {
					const list = res.data.ipv6Addresses.map(item => {
						item.chargeMode = item.charge.chargeMode;
						if (item.chargeMode) {
							item.chargeModeName = this.ChargeModeMap[item.charge.chargeMode.toUpperCase()];
							item.chargeStatus = item.charge.chargeStatus;
							item.chargeStartTime = item.charge.chargeStartTime;
						}
						return item;
					});
					this.tableData = list;
					this.total = res.data.totalCount;
					// this.refreshLoading = false;
				})
				.catch(err => {
					// this.refreshLoading = false;
					console.log(err);
				}).finally(() => {
                    this.$nextTick(function () {
                        this.refreshLoading = false;
                    })
                });
			},
			getServerData() {
				let params = {
					region: this.region,
					ipv6GatewayId: this.ipv6GatewayId
				};
				Ajax.get('/api/cps/ipv6Gateways', params)
				.then((res) => {
					this.refreshLoading = false;
					this.gridData = res.data.ipv6Gateway;
					this.initOperates();
				})
				.catch(err => {
					this.refreshLoading = false;
					console.log(err);
				});
			},
			getUserType() {
				const params = {
					region: this.region
				};
				Ajax.get('/api/usercenter/describeBaseInfo', params)
				.then((res) => {
					const meta = JSON.parse(res.data.meta);
					this.isVip = meta.edcps_vip.toString() === '1';
				});
			},

			// 操作下拉选初始化，绑定、解绑、调整带宽、续费、删除
			initOperates() {
				this.availableOperatesArray = this.operatesArr.map((key) => {
					const {name} = this.$t(`ipv6.operations.${key.toString().toLowerCase()}`);
					const item = {
						value: Ipv6OperationConstant[key],
						operateName:name,
						ifShow: true,
						disabled: false
					};
					return item;
				});
			},
			jumpToUp() {
				this.$router.push({
					name: 'Ipv6List',
					params: {region: this.region}
				});
			},
			jumpToCreate() {
				this.$router.push({
					path: '/ipv6/create',
					query: {
						ipv6GatewayId: this.ipv6GatewayId,
						subnetId: this.subnetId,
					},
				});
			},
			jumpToVpcDetail(tabName, vpcName, vpcId) {
	            this.$router.push({
	                path: '/vpc/detail',
	                query: {
	                    region: this.region,
	                    vpcName,
	                    tabName,
	                    id: vpcId
	                }
	            });
			},
			selectOps(item) {
				switch (item) {
					case Ipv6OperationConstant.MANAGE: {
						if(item.disabled){
							return false;
						}
						this.bindDialogVisible = true;
						break;
					}
				}
			},
			copyToClipboard() {
				this.copyHover = true;
			},
			failToCopy() {
				console.log('Failed to copy texts');
			},
			// 修改搜索条件
			changeSearch() {
				const searchPlaceholder = this.$t('ipv6.placeholder.search');
				const currentSearchVar = this.currentSearch;
				this.currentPlaceholder = searchPlaceholder[currentSearchVar];
				// 清空当前搜索条件
				this.currentSearchValue = '';
			},
			// 切换每一页多少条
			handleSizeChange(val) {
				this.pageSize = val;
				this.getIpv6ListData();
			},
			// 切换当前页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getIpv6ListData();
			},

			disableByChargeStatus(row) {
				if (OverdueConstantArray.includes(row.charge.chargeStatus)) {
					return true;
				}
				return false;
			},

            deleteIpv6Address(row) {
                // this.canNotDelete ||
				if (!row.charge.chargeStatus) {
					return false;
				}
            	this.currentRow = row;
            	this.deleteIpv6Visible = true;
            },

            modifyBandwidth(row) {
				if (!row.charge.chargeStatus || this.disableByChargeStatus(row)) {
					return false;
				}
            	this.currentRow = row;
            	this.currentRow.chargeMode = this.currentRow.charge.chargeMode;
            	this.modifyDialogVisible = true;
            },
            handleCanNotDelete () {
                // this.refreshLoading = true;
                this.canNotDelete = true;
            },
            handleCanDelete () {
                // this.refreshLoading = false;
                this.canNotDelete = false;
            },
            operateRefresh() {
            	this.resetIpv6ListParams();
            	this.getIpv6ListData();
            },

            resetIpv6ListParams() {
            	this.currentPage = defaultPage;
            	this.pageSize = defaultPageSize;
            	this.currentSearchValue = '';
            },

            syncModifyDialogVisibleData(data) {
				this.modifyDialogVisible = data;
			},

			updateList(type) {
				if (type === 'refresh') {
					this.currentPage = defaultPage;
            		this.pageSize = defaultPageSize;
				}
				this.getIpv6ListData();
			},

			transformCharge(type) {
				switch (type) {
					case 'rip':
					return this.$t('ipv6.text.rip');
					case 'aliasip':
					return this.$t('ipv6.text.aliasip');
					default:
					return '';
				}
			},

			// 编辑名称
			editName(value) {
              	const nameRes = Ajax.post('/api/cps/ipv6Gateways', {
                    ipv6GatewayId: this.gridData.ipv6GatewayId,
                    region: this.region,
          	      	ipv6GatewayName: value,
          	      	clientToken: Normal.getClientToken(),
              	}).then((res)=>{
              		this.gridData.ipv6GatewayName = res.data.ipv6Gateway.ipv6GatewayName;
              	}).catch(async (err) => {
                  	const {response} = err.data;
                    try {
						const json = await response.json();
						this.$message.error(json.errmsg);
                    } catch (ex) {
                      	console.log(ex);
                    }
                })
			},
		}
	};
</script>

<style lang="scss">
	@import '../../../assets/scss/listComon.scss';
	@import '../../../assets/scss/paginationCommon';
	@import '~@/assets/scss/detailCommon.scss';
	@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/ipv6/detail/Detail.vue